import { Component } from '@angular/core';
import { FieldComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-progress',
  templateUrl: './app-progress.component.html',
})
export class AppProgressComponent extends FieldComponent {
}
